import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const PageFragment = gql`
  fragment PageFragment on Page {
    id
    pageId
    title

    slug
    body

    status

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query PageGet($pageId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        pages {
          id
          get(pageId: $pageId) {
            ...PageFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${PageFragment}
`;

export const list = gql`
  query PageList($input: ListInput) {
    viewer {
      id
      account {
        id
        pages {
          id
          list(input: $input) {
            id
            last
            items {
              ...PageFragment
            }
          }
        }
      }
    }
  }
  ${PageFragment}
`;




export const create = gql`
  mutation PageNew($input: PageInputCreate!) {
    viewer {
      account {
        pages {
          create(input: $input) {
            ...PageFragment
          }
        }
      }
    }
  }
  ${PageFragment}
`;



export const edit = gql`
  mutation PageEdit(
    $pageId: String!
    $input: PageInputUpdate!
  ) {
    viewer {
      account {
        pages {
          get(pageId: $pageId) {
            update(input: $input) {
              ...PageFragment
            }
          }
        }
      }
    }
  }
  ${PageFragment}
`;


export const remove = gql`
  mutation PageRemove($pageId: String!) {
    viewer {
      account {
        pages {
          get(pageId: $pageId) {
            remove
          }
        }
      }
    }
  }

`;




// The literal below must equal what PageQueries.id resolves to on the API side
// (api/code/src/schema/account/page). If the two drift, a create succeeds and
// every list screen keeps serving the pre-create page with no error anywhere.
// api/code/test/schema.test.js pins the other half.
export const update = ({ pageId }) => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`pages/queries`)) {
      cache.data.delete(key);
    }
  });
};
